import React from "react";
import Button from "../../../../../Button";
import LoadingOverlay from "react-loading-overlay";
import { gql, useMutation } from "@apollo/client";

const UPLOAD_CSV = gql`
  mutation NFLProjectionsAdminUploadCSVMutation($csv: Upload!) {
    uploadNflPlayerProjections(csvFile: $csv) {
      success
    }
  }
`;

export default function NFLProjectionsAdmin() {
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState(undefined);

  const [uploadCSV] = useMutation(UPLOAD_CSV);

  function onFileUpload(e) {
    e.preventDefault();

    setFile(e.target.files[0]);
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!file) {
      return;
    }

    setLoading(true);

    uploadCSV({ variables: { csv: file } })
      .then(() => setLoading(false))
      .catch(() => {
        setLoading(false);
        alert("Something went wrong.");
      });
  }

  return (
    <div>
      <Button href="/tools/nfl/projections" style={{ marginBottom: "-20px" }}>
        Back
      </Button>
      <LoadingOverlay
        spinner
        active={loading}
        text={"Uploading projections..."}
      >
        <div className="gm-admin-container">
          <h1>Upload Projections</h1>
          <label htmlFor="csv-file">CSV: </label>
          <input id="csv-file" type="file" onChange={onFileUpload} />
          <br />
          <br />
          <Button form={true} onClick={onSubmit} style={{ margin: "inherit" }}>
            Submit
          </Button>
        </div>
      </LoadingOverlay>
    </div>
  );
}
